import { SVGProps, Ref, forwardRef } from 'react';

export const RotateLeftOultinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="m8.876 5.131.99-.99-.872-.871c.907.008 1.62.033 2.204.111.83.112 1.294.32 1.63.656.337.336.545.801.656 1.631.114.85.116 1.973.116 3.564v.1H15V9.18c0-1.527 0-2.744-.128-3.698-.133-.986-.413-1.795-1.053-2.435s-1.45-.92-2.435-1.053c-.667-.09-1.46-.117-2.398-.125l.88-.88L8.876 0 6.31 2.566z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 11c0-4.375.625-5 5-5s5 .625 5 5-.625 5-5 5-5-.625-5-5m1.4 0c0-1.083.04-1.831.142-2.368.098-.523.23-.705.307-.783.078-.077.26-.209.783-.307C4.17 7.44 4.917 7.4 6 7.4s1.831.04 2.368.142c.523.098.705.23.783.307.077.078.209.26.307.783C9.56 9.17 9.6 9.917 9.6 11s-.04 1.831-.142 2.368c-.098.523-.23.705-.307.783-.078.077-.26.209-.783.307-.537.101-1.285.142-2.368.142s-1.831-.04-2.368-.142c-.523-.098-.705-.23-.783-.307-.077-.078-.209-.26-.307-.783C2.44 12.83 2.4 12.083 2.4 11"
            fill="currentColor"
        />
    </svg>
));
RotateLeftOultinedSize16Glyph.displayName = 'RotateLeftOultinedSize16Glyph';
